import { useStoreValue } from '../store'
import { EnumUserRoles } from 'utils'

export const useCheckUserPermission = (
	role: EnumUserRoles,
	entityCompany?: any,
): boolean => {
	const loggedUser = useStoreValue()[0].user
	const userCompanyRoles =
		loggedUser?._UserToCompanyRoleCollection?.edges?.map(
			(item: any) => item.node.companyRole,
		)
	let result = null
	if (!loggedUser) return false
	if (loggedUser.god) {
		// check if the logged user is god
		result = true
	} else if (role && entityCompany) {
		let checkIfLoggedUserOwnsCompany =
			loggedUser.profileCollection?.edges[0].node.user
				?._OwnerToCompanyCollection?.edges &&
			loggedUser.profileCollection?.edges[0].node.user
				?._OwnerToCompanyCollection?.edges.length > 0
				? loggedUser.profileCollection?.edges[0].node.user?._OwnerToCompanyCollection?.edges.find(
						item => item.node.company.id === entityCompany.id,
				  )
				: undefined
		if (checkIfLoggedUserOwnsCompany) {
			// check if the logged user owned the company that is related with the entity (article, job, company, etc)
			result = checkIfLoggedUserOwnsCompany
		} else {
			// check if the user has the access
			result = userCompanyRoles?.find(
				item =>
					item.company.id === entityCompany.id &&
					item.roles.includes(role),
			)
		}
	}

	return result ? true : false
}
